import React, { useState, useRef } from "react";
import useFetch from "../../../../context/useFetch";
import { toast } from "react-toastify";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

// import JS files
import MuiButton from "../../../shares/MuiButton";

const AdminReportsPrintInventory = () => {
  const navigate = useNavigate();

  const [requestList, setRequestList] = useState({ results: [] });

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const getRequestListApi = useFetch({
    method: "get",
    params: {},
    url: "BangleStock_Service",
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const componentRef = useRef();

  return (
    <>
      <div className="my-4">
        <div className="flex justify-between items-center mx-8">
          <span className="text-sm">برای دانلود فایل PDF کلیک کنید.</span>
          <div className="flex">
            <ReactToPrint
              trigger={() => {
                return (
                  <MuiButton
                    variant="contained"
                    color="primary"
                    text="دانلود فایل PDF"
                    size="small"
                    //    icon={<ModeEditIcon />}
                  />
                );
              }}
              content={() => componentRef.current}
            />
            <div className="mr-4">
              <MuiButton
                onClick={() => navigate(-1)}
                variant="outlined"
                color="secondary"
                text="بازگشت"
                size="small"
                icon={<ArrowBackIcon />}
              />
            </div>
          </div>
        </div>
        <div
          className="printTable mx-8"
          ref={componentRef}
          style={{ direction: "rtl" }}
        >
          <div className="text-center mt-8">
            <span className="font-bold">موجودی</span>
          </div>
          <div className="border rounded-md mt-4 overflow-hidden">
            <div className="flex justify-between">
              <div className="basis-1/2  text-center py-1 ">
                <span className="text-sm text-myblue-100">ردیف</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">کد</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">النگو</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">سن</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">رنگ</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تعداد یک</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تعداد دو</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تعداد سه</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تعداد چهار</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تعداد پنج</span>
              </div>
              <div className=" basis-1/2 text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">تعداد شش</span>
              </div>
            </div>

            {requestList.results.map((item, index) => {
              return [
                <>
                  <div className="printTableTr flex justify-between">
                    <div className="basis-1/2 border-t  text-center py-1">
                      <span className="text-sm text-myblue-100">
                        {index + 1}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.code}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.show_name}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.gender == "woman" ? "زنانه" : "بچه گانه"}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.color == "yellow" ? "زرد" : "سفید"}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.size_one_num}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.size_two_num}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.size_three_num}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.size_four_num}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.size_five_num}
                      </span>
                    </div>
                    <div className=" basis-1/2 border-t text-center py-1 border-r">
                      <span className="text-sm text-myblue-100">
                        {item.size_six_num}
                      </span>
                    </div>
                  </div>
                  {index == 21 ? <div className="break"></div> : undefined}
                </>,
              ];
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminReportsPrintInventory;
